export { SingleAccommodationsPointPage } from "./single-accommodations-point-page";
